<div class="container-fluid custom-width">
    <div class="row my-3">
        <div class="col-lg-6">
            <h2>Get In Touch with Us!</h2>
            <form action="">
                <div class="d-flex flex-column mb-2">
                    <label for="name">Name</label>
                    <input type="text" pInputText required>
                </div>
                <div class="d-flex flex-column mb-2">
                    <label for="name">Email</label>
                    <input type="email" pInputText required>
                </div>
                <div class="d-flex flex-column mb-2">
                    <label for="name">Contact</label>
                    <p-inputNumber [maxlength]="10" [required]="true"></p-inputNumber>
                </div>
                <div class="d-flex flex-column mb-2">
                    <label for="name">Message</label>
                    <textarea rows="5" cols="30" pInputTextarea></textarea>
                </div>
                <div class="float-right">
                    <p-button type="button" label="Submit" styleClass="p-button-rounded"></p-button>
                </div>
            </form>
        </div>
        <div class="col-lg-6">
            <div class="card">
                <div class="card-body">
                    <h6>Contact Person :</h6>
                    <p>A.R Bharathkumar B.Tech</p>
                    <h6>Address :</h6>
                    <p>Shed No: 4-5, Plot No:6-10, 24, 42-45, SIDCP Industrial Estate, Aundipatty-625512. Theni
                        District.</p>
                    <h6>Telefax :</h6>
                    <p>04546242783</p>
                    <div class="social-media">
                        <a href="" class="fb"></a>
                        <a href="" class="insta"></a>
                        <a href="" class="mail"></a>
                        <a href="" class="phone"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>